<footer>
	<p>Open source available on <a href="https://github.com/jasonlutterloh/hodltracker" target="_blank">GitHub</a> | <a href="https://hodl.lutterloh.dev/privacy" target="_blank">Privacy Policy and Terms of Use</a></p>
</footer>

<style>
	footer{
		font-size: .8em;
		text-align: center;
	}
	a{
		color: var(--text-color);
	}
	@media only screen and (max-width: 568px) {
		footer {
			flex-direction: column;
		}
	}
</style>